import React, { useLayoutEffect } from "react";
import axios from "axios";
import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { getUserData } from "../Apis/UserApi";
import { URL } from "../Urls";
import { loginAction } from "../redux/MyActions";
import { useHistory } from "react-router-dom";
import { DualRing } from "react-awesome-spinners";

const AuthenticationProvider = ({ children, ...props }) => {

    const history = useHistory()

    const [isAuthenticationPending, setIsAuthenticationPending] = useState(false);

    const fetchUserData = async () => {
        const userData = await getUserData();
        if (userData) {
            props.doLogin(userData);
        }
    };

    const checkAuthentication = () => {
        if (isAuthenticationPending) return;
        setIsAuthenticationPending(true)
        axios({
            method: "post",
            //url: "https://sdql-testapp.herokuapp.com/isAuthenticated/",
            url: URL + "isAuthenticated/",
            data: {
                jwtCookie: props.jwtCookie,
            },
        }).then((res) => {
            if (res.data.message === "OK") {
                props.doLogin();
                fetchUserData();
            } else {
                console.log("replace")
                history.replace("/login");
            }
        }).finally(() => setIsAuthenticationPending(false));
    }

    useLayoutEffect(() => {
        checkAuthentication()
    }, []);

    if (isAuthenticationPending) {
        return (
            <div className="main-loader">
              <DualRing size={100} color="#30aaba" width={100} height={100} />
            </div>
        );
    }
 

    return children
}


const mapStateToProps = (state) => {
    return {
        jwtCookie: state.jwtCookie,
        authState: state,
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        doLogin: (payload) => dispatch(loginAction(payload)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthenticationProvider);